import { noop } from 'lodash';
import callOrLog from 'common/utils/callOrLog';

function initiateSocialCoverageEventTracking({ eventTracker = noop, eventName = '' }) {
  callOrLog(() => eventTracker(
    eventName,
    { insurance_types: ['social'] },
  ));
}

export default initiateSocialCoverageEventTracking;
